"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dynatraceInstance = exports.getDynatraceInstance = void 0;
const web_ui_features_1 = require("@gruposantander/web-ui-features");
let instance = null;
const getDynatraceInstance = () => {
    if (!instance) {
        instance = new web_ui_features_1.DynatraceWrapper();
    }
    return instance;
};
exports.getDynatraceInstance = getDynatraceInstance;
exports.dynatraceInstance = {
    getInstance: exports.getDynatraceInstance,
};
//# sourceMappingURL=index.js.map